import styled from 'styled-components';

export const StatusBarStyled = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.size.rap};

  .time {
    padding: 0.5rem 0.75rem;
    border-radius: 500px;
    background: #fff;
  }

  .Button {
    border-radius: 500px;
  }
`;
